import React, { Component } from 'react'
import { MuiButton, MuiTypography } from '../../../ui';
import { Redirect } from 'react-router-dom';
import routes from '../../../navigation/Routes';
import Security from '../../../../security';
import theme from '../../../../assests/theme'
import { withRouter } from 'react-router-dom';
class SignOut extends Component {

  onSignOutClick = () => {
    localStorage.setItem('rememberMe', 'false');
    this.props.user.signOut()
    document.location.href = '/'
  }


  render() {
    return (
      <MuiTypography variant={theme.typographyStyles.BODY2} style={{ color: theme.palette.primary.darker, cursor: 'pointer', textDecoration: 'none' }} onClick={this.onSignOutClick}>Sign Out</MuiTypography>
    )
  }
}
export default withRouter(SignOut);
